<template lang="html">
  <d-tabs class="w-100 mb-4 px-1" ref="tabs">
    <d-tab title="Status" class="p-3">
      <d-form-row>
        <project-status />
      </d-form-row>
    </d-tab>
    <d-tab title="Anexos" class="py-2">
      <d-form-row>
        <project-files />
      </d-form-row>
    </d-tab>
    <d-tab title="Chamados" class="py-2" v-if="hasAccessTickets">
      <d-form-row>
        <project-tickets />
      </d-form-row>
    </d-tab>
  </d-tabs>
</template>

<script>
import ProjectFiles from './tabs/ProjectFiles.vue';
import ProjectStatus from './tabs/ProjectStatus.vue';
import ProjectTickets from './tabs/ProjectTickets.vue';

export default {
  name: 'project-tabs',
  components: {
    ProjectFiles,
    ProjectStatus,
    ProjectTickets,
  },
  computed: {
    status() {
      const { status } = this.$store.state.project;
      if (status) {
        return status;
      }
      return [];
    },
    hasAccessTickets() {
      const { modules } = this.$store.state.user;
      return modules.includes('tickets');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~_scss/overrides';

.tab-pane {
  border: 1px solid #e1e5eb;
  border-top: 0;
}
.link {
  cursor: pointer;
  color: $primary;
  font-size: 0.7rem;
  margin-left: 10px;
  &:hover {
    text-decoration: underline;
  }
}
</style>
